'use strict';

import $ from 'jquery';

$(function(){

  //----------------------------------------------
  // ハンバーガーメニュー（スマホ用のサイドメニュー表示）
  //----------------------------------------------
  $('#js-btn-drawer').on( 'click', function(){
    $('#js-drawer-nav').toggleClass('is-active');
    return false;
  });
});
